/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_What_Is_Gridcraft_Sections_3_Paragraphs_0Inputs */

const en_gc_search_guides_what_is_gridcraft_sections_3_paragraphs_0 = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_3_Paragraphs_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For a desktop download, match the operating system and CPU architecture instead of choosing the first asset in a release. The homepage links to the pinned v0.7.0 packages; the upstream releases page may offer newer builds. Read the release notes if you choose a different version.`)
};

const zh_gc_search_guides_what_is_gridcraft_sections_3_paragraphs_0 = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_3_Paragraphs_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下载桌面版时，应匹配操作系统和 CPU 架构，而不是直接选择发布页中的第一个文件。首页链接到固定的 v0.7.0 安装包，上游发布页可能有更新版本。如果选择其他版本，应阅读相应发布说明。`)
};

/**
* | output |
* | --- |
* | "For a desktop download, match the operating system and CPU architecture instead of choosing the first asset in a release. The homepage links to the pinned v0..." |
*
* @param {Gc_Search_Guides_What_Is_Gridcraft_Sections_3_Paragraphs_0Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_what_is_gridcraft_sections_3_paragraphs_0 = /** @type {((inputs?: Gc_Search_Guides_What_Is_Gridcraft_Sections_3_Paragraphs_0Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_What_Is_Gridcraft_Sections_3_Paragraphs_0Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_what_is_gridcraft_sections_3_paragraphs_0(inputs)
	return zh_gc_search_guides_what_is_gridcraft_sections_3_paragraphs_0(inputs)
});
export { gc_search_guides_what_is_gridcraft_sections_3_paragraphs_0 as "gc.search_guides.what_is_gridcraft.sections.3.paragraphs.0" }